import { FC } from "react";
import { AirplaneIcon } from "src/assets/Icons";
import { RowSeat, SeatType } from "src/Modules/Flights/constants/JourneyDetails";
import ColumnHeader from "../components/ColumnHeader/ColumnHeader";
import RowSeating from "../components/RowSeating/RowSeating";

interface PlaneSeatingWebProps {
  colMap: Map<number, string>;
  rows?: RowSeat[];
  craftType?: string;
  reservedSeats: string[];
  onClick: (val: SeatType) => void;
  flightId?: string | number;
}

const PlaneSeatingWeb: FC<PlaneSeatingWebProps> = ({ colMap, rows, craftType, reservedSeats, onClick, flightId }) => {
  return (
    <div className="rounded-16 border-border-subtle bg-background-minimal font-poppins border p-6">
      <div className="rounded-t-80 border-border-subtle bg-background-default flex flex-col gap-5 rounded-b-3xl border px-6 pt-8 pb-8">
        <div className="text-font-minimal flex w-full flex-col items-center justify-center gap-1 text-xs">
          <span className="bg-background-subtle h-1 w-12 rounded-full" />
          <AirplaneIcon className="h-4 w-4" transform="rotate(-90)" />
          <span>{craftType}</span>
        </div>
        <div className="flex w-full flex-1 flex-col items-center justify-center gap-2 md:gap-3">
          <ColumnHeader colMap={colMap} />

          {rows?.map((row: RowSeat, index: number) => (
            <RowSeating key={`${flightId}-${index}`} colMap={colMap} row={row} onClick={onClick} reservedSeats={reservedSeats} isMobile={false}/>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PlaneSeatingWeb;
